import { call, put, takeEvery } from 'redux-saga/effects';
import * as onlineStoreApi from 'api/onlineStore';
import {
  ONLINE_STORE_DISCONNECT_SHOP,
  ONLINE_STORE_PAGE_REQUEST,
} from 'actions/onlineStore/constants';
import * as onlineStoreAction from 'actions/onlineStore';
import * as actionNotification from 'actions/notifications';
import * as action from 'actions';
import * as fbClevertap from 'clevertap/onlineStore/facebook';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';

function* fetchData(api, ...params) {
  const response = yield call(api, ...params);
  return response.data;
}

function* shopPageRequest({ payload }) {
  const { channel } = payload;

  yield put(action.showProgressBar());
  yield put(onlineStoreAction.closeOutletModal());
  yield put(onlineStoreAction.loadingPageRequest());

  try {
    const data = yield fetchData(onlineStoreApi.getShops, channel, true);
    const businessInfo = yield fetchData(onlineStoreApi.getBusinessInfo);

    yield put(onlineStoreAction.setShops(data.shops));
    yield put(onlineStoreAction.setBusinessInfo(businessInfo));
    yield put(onlineStoreAction.finishPageRequest());
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

function* disconnectShop({ payload }) {
  const { shop, outlet } = payload;

  try {
    yield put(action.showLoadingSpinner(true));
    yield call(onlineStoreApi.deleteShop, shop.id);
    yield put(onlineStoreAction.closeDisconnectShopModal());
    yield put(onlineStoreAction.pageRequest(shop.channel));

    fbClevertap.fbDisconnectSuccess();

    yield put(actionNotification.success(getDiconnectedMessage(shop, outlet)));
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(action.showLoadingSpinner(false));
  }
}

function getDiconnectedMessage(shop, outlet) {
  if (shop.channel === ONLINE_STORE_CHANNEL.FACEBOOK) {
    return `${shop.additional.facebook_page_name} has been successfully disconnected from Facebook & Instagram Shop.`;
  }

  return `${outlet.name} has been successfully disconnected from Google.`;
}

export default function* shopSaga() {
  yield takeEvery(ONLINE_STORE_PAGE_REQUEST, shopPageRequest);
  yield takeEvery(ONLINE_STORE_DISCONNECT_SHOP, disconnectShop);
}
